import BlogPostList from './BlogPostList'

export default BlogPostList
